import { Chain } from '@ankr.com/chains-list';
import { Code } from '@ankr.com/ui';

import { CodeExampleModal } from 'modules/chains/components/CodeExampleModal';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useHasCodeExample } from 'modules/chains/hooks/useHasCodeExample';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { ChainMenuItem } from '../ChainMenuItem';
import { codeExampleMenuItemTranslation } from './translation';

interface CodeExampleMenuItemProps {
  chain: Chain;
  closeMenu: () => void;
}

export const CodeExampleMenuItem = ({
  chain,
  closeMenu,
}: CodeExampleMenuItemProps) => {
  const hasCodeExample = useHasCodeExample(chain);

  const {
    isOpened: isCodeExampleDialogOpened,
    onClose: closeCodeExampleDialog,
    onOpen: openCodeExampleDialog,
  } = useDialog();

  const { keys, t } = useTranslation(codeExampleMenuItemTranslation);

  if (!hasCodeExample) {
    return null;
  }

  const onClick = () => {
    closeMenu();
    openCodeExampleDialog();
  };

  return (
    <>
      <ChainMenuItem Icon={Code} onClick={onClick}>
        {t(keys.codeExample)}
      </ChainMenuItem>
      <CodeExampleModal
        isOpenedCodeExample={isCodeExampleDialogOpened}
        chain={chain}
        onCloseCodeExample={closeCodeExampleDialog}
      />
    </>
  );
};
